var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTiktokblack1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 30,
    viewBox: "0 0 32 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 30,
    rx: 15,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.633 8.70937C20.7962 7.85573 20.335 6.75966 20.3351 5.625H16.5514V19.1875C16.5228 19.9216 16.1762 20.6171 15.5844 21.1272C14.9927 21.6374 14.2023 21.9223 13.38 21.9218C11.6412 21.9218 10.1963 20.6531 10.1963 19.0781C10.1963 17.1968 12.229 15.7859 14.3228 16.3657V12.9094C10.0984 12.4062 6.40039 15.3375 6.40039 19.0781C6.40039 22.7203 9.77999 25.3125 13.3678 25.3125C17.2127 25.3125 20.3351 22.5234 20.3351 19.0781V12.1985C21.8694 13.1827 23.7114 13.7108 25.6004 13.7078V10.3281C25.6004 10.3281 23.2983 10.4266 21.633 8.70937Z",
    fill: "#0B101B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokblack1);
export default __webpack_public_path__ + "static/media/tiktokblack1.95e46bd1bcbda61623ae88495ecee3c4.svg";
export { ForwardRef as ReactComponent };